'use client'

import ProductCard, { ProductForProductCard } from '../../components/ProductCard'
import { useWindowSize } from '../../hooks/useWindowSize'
import { LoadableComponentProps } from '../../types'

type ProductGridProps = LoadableComponentProps<{
  products: ProductForProductCard[]
  onAddToBasketClick: (variantId: string) => Promise<void>
  onCardClick: () => void
  loadingProductsCount?: number
  accessibility?: {
    price?: string
    compareAtPrice?: string
  }
}>

export default function ProductGrid({ data, loading }: ProductGridProps) {
  const { windowSize } = useWindowSize()

  return (
    <ul
      data-testid={loading ? '' : 'product-grid'}
      className='grid grid-cols-4 gap-x-4 gap-y-10 px-5 md:grid-cols-12 lg:gap-x-5 lg:gap-y-12 xl:px-10'
    >
      {loading ? (
        <>
          {Array.from({ length: 3 }, (_, index) => (
            <li key={`loading-product-card-${index}`} className='col-span-2 md:col-span-4'>
              <ProductCard
                loading
                imageSizes='(min-width: 768px) 50vw, 100vw'
                className='aspect-[2/3] lg:aspect-[8/9]'
                shoppingButtonSize={windowSize.width >= 1280 ? 'normal' : 'small'}
              />
            </li>
          ))}
        </>
      ) : (
        <>
          {data.products.map((product, index) => (
            <li key={product.variantId} className='col-span-2 md:col-span-4'>
              <ProductCard
                imagePriority={index < 3}
                imageSizes='(min-width: 768px) 50vw, 100vw'
                className='aspect-[2/3] lg:aspect-[8/9]'
                onAddToBasketClick={data.onAddToBasketClick}
                shoppingButtonSize={windowSize.width >= 1280 ? 'normal' : 'small'}
                onCardClick={data.onCardClick}
                data={{
                  ...product,
                  accessibility: { ...data.accessibility, ...product.accessability },
                }}
              />
            </li>
          ))}

          {data.loadingProductsCount != null &&
            data.loadingProductsCount !== 0 &&
            Array.from({ length: data.loadingProductsCount }, (_, index) => (
              <li
                key={`loading-product-card-${index}`}
                className='radius-sm block h-[327px] w-40 animate-pulse overflow-hidden bg-black xl:h-[689px] xl:w-[400px]'
              />
            ))}
        </>
      )}
    </ul>
  )
}
